import { Box, Image, Typography, useTheme } from "@outschool/backpack";
import { useIsMobile } from "@outschool/ui-utils";
import React, { RefObject } from "react";

import { useTopValues } from "./hooks/useTopValues";

const ValueItem = ({
  src,
  altText,
  title
}: {
  src: string;
  altText: string;
  title: string;
}) => {
  const theme = useTheme();
  const isMobile = useIsMobile();

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: theme.palette.common.black
      }}
    >
      <Image
        sx={{
          width: "3.5rem",
          height: "3.5rem",
          paddingRight: "0.3rem"
        }}
        src={src}
        alt={altText}
      />

      <Typography
        emphasized
        variant={`${isMobile ? "subtitle1" : "h6"}`}
        sx={{
          whiteSpace: "nowrap"
        }}
      >
        {title}
      </Typography>
    </Box>
  );
};

export default function TutoringValues({
  scrollToRef
}: {
  scrollToRef: RefObject<HTMLElement | null>;
}) {
  const isMobile = useIsMobile();
  const valueDescriptions = useTopValues();

  const onTutValueClick = () => {
    scrollToRef?.current?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: `${isMobile ? "column" : "row"}`,
        gap: `${isMobile ? "1.5rem" : "4rem"}`,
        justifyContent: "center",
        alignItems: "center",
        cursor: "pointer"
      }}
      onClick={() => onTutValueClick()}
    >
      {valueDescriptions.map(({ image, alt, imageTitle }, index) => (
        <ValueItem
          src={image}
          altText={alt}
          title={imageTitle}
          key={`${index}-${imageTitle}`}
        />
      ))}
    </Box>
  );
}
